// @flow

const name = 'ACCESS_TOKEN';

export const setToken = (token: string) => localStorage.setItem(name, token);

export const getToken = () => localStorage.getItem(name);

export const clearToken = () => localStorage.removeItem(name);

export const isAuthenticated = () => {
  const token = getToken(name);

  return !!token;
};



// WEBPACK FOOTER //
// ./src/helpers/auth.js